<div class="main">
  <div class="top_one">

  </div>
  <div class="container-fluid top_main">
    <div class="row">
      <div class="col-lg-4">
        <div class="left_first_box">
          <div class="new_box">NEW REVOLUTIONIZED</div>
          <h1 id="text">INTERNET MARKETING SOLUTIONS</h1>
        </div>
        <div class="video-box">
        
          <video
            id="my-video"
            class="video-js video-size w-100 h-auto"
            controls
            preload="auto"
            poster="{{ myLinksS3URL }}Image0ywt7w2.png"
            data-setup="{}"
          >
            <source
              src="{{ myLinksS3URL }}videos/Onpassive_launching_page_video2.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="mid_box">
          <div class="globe" id="loading">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-sept(3)/images/glob.png"
              class="img-fluid"
              alt="image"
            />
          </div>
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-sept(3)/images/logo.png"
              class="img-fluid"
              alt="logo"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="right_box">
          <h1>LAUNCHING SOON!</h1>
          
          <p class="acc_panel anim_in">
            Do you want a life-long income while enjoying time with your family?
            If yes, then ONPASSIVE is the perfect platform to get exactly what
            you need. The world's most potential income solution is awaiting a
            grand launch soon. Come.. join us immediately as 576647+ people
            worldwide are already ahead of you and more are joining everyday.
            You can just sit back and enjoy the ride.
          </p>

          <a
            href="/registration/user?reg={{ userId }}"
            name="regform"
            target="_blank"
            rel="noopener"
            class="btn11"
            data-aos="zoom-in"
            ><span>BECOME A FOUNDER NOW</span>
            <div class="transition"></div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="container top_main">
    <div class="row justify-content-center mt-lg-5 mt-sm-0">
      <div class="col-lg-4">
       
      </div>
    </div>
  </div>
</div>
